import * as tslib_1 from "tslib";
import React from 'react';
import FormControlWrapper from './FormControlWrapper';
import FormControlContent from './FormControlContent';
import FormLabel from './FormLabel';
import FormHelpText from '../FormHelpText';
import { removeUndefinedProperties } from '../../utils/objects';
/**
 * 渲染表单控件
 *
 * @param {any} { control, ...props }
 * @returns
 */
function renderControl(_a) {
    var control = _a.control, props = tslib_1.__rest(_a, ["control"]);
    return typeof control === 'function'
        ? control(props)
        : React.cloneElement(control, props);
}
/**
 * 渲染标签
 *
 * @param {(FormControlLabelProps & {
 *   label: React.ReactNode | ((props: FormControlLabelProps) => React.ReactNode);
 * })} {
 *   label,
 *   ...props
 * }
 * @returns
 */
function renderLabel(_a) {
    var label = _a.label, props = tslib_1.__rest(_a, ["label"]);
    if (label && typeof label === 'function') {
        return label(props);
    }
    else if (label) {
        return React.createElement(FormLabel, tslib_1.__assign({}, props), label);
    }
    return null;
}
/**
 * 表单控件
 *
 * @ReactComponent
 *
 * @export
 * @class FormControl
 * @extends {React.Component}
 */
var FormControl = /** @class */ (function (_super) {
    tslib_1.__extends(FormControl, _super);
    function FormControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            focused: false,
        };
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
    }
    FormControl.prototype.onFocus = function () {
        if (this.props.readOnly) {
            return;
        }
        this.setState({
            focused: true,
        });
    };
    FormControl.prototype.onBlur = function () {
        if (this.props.readOnly) {
            return;
        }
        this.setState({
            focused: false,
        });
    };
    FormControl.prototype.render = function () {
        var _a = this.props, inline = _a.inline, label = _a.label, labelAlign = _a.labelAlign, name = _a.name, colon = _a.colon, required = _a.required, labelStyle = _a.labelStyle, labelClassName = _a.labelClassName, labelWidth = _a.labelWidth, validateState = _a.validateState, vertical = _a.vertical, helpText = _a.helpText, validateText = _a.validateText, disabled = _a.disabled, readOnly = _a.readOnly, props = tslib_1.__rest(_a, ["inline", "label", "labelAlign", "name", "colon", "required", "labelStyle", "labelClassName", "labelWidth", "validateState", "vertical", "helpText", "validateText", "disabled", "readOnly"]);
        var controlProps = removeUndefinedProperties(tslib_1.__assign({ name: name, id: name, required: required,
            validateState: validateState }, props));
        var labelProps = removeUndefinedProperties({
            label: label,
            name: name,
            required: required,
            warning: validateState === 'warning',
            error: validateState === 'error',
            width: labelWidth,
            style: labelStyle,
            className: labelClassName,
            focused: this.state.focused,
            align: labelAlign,
            vertical: vertical,
            disabled: disabled,
            colon: colon,
            readOnly: readOnly,
        });
        return (React.createElement(FormControlWrapper, { inline: inline, vertical: vertical, onFocus: this.onFocus, onBlur: this.onBlur },
            renderLabel(labelProps),
            React.createElement(FormControlContent, null,
                renderControl(controlProps),
                typeof helpText === 'string' ? (React.createElement(FormHelpText, null, helpText)) : (helpText),
                typeof validateText === 'string' ? (React.createElement(FormHelpText, { warning: validateState === 'warning', error: validateState === 'error', success: validateState === 'success' }, validateText)) : (validateText))));
    };
    return FormControl;
}(React.Component));
export default FormControl;
//# sourceMappingURL=FormControl.js.map